import { fetchEmployeesGroups, selectEmployeesGroups, toUnifiedGroupTreeNode } from "@/entities/groups"
import { GroupTree } from "@/features/groups"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { useMemo } from "react"

export const GroupsGrid = () => {
    const groups = useAppSelector(selectEmployeesGroups)
    const dispatch = useAppDispatch()
    const onUpdate = () => {
        dispatch(fetchEmployeesGroups())
    }

    const treeItems = useMemo(() => toUnifiedGroupTreeNode(groups), [groups])
    const roots = useMemo(() => treeItems.filter(i => i.data.parent === null), [treeItems])

    return (
        <div className="grid grid-cols-12 gap-4">
            {roots.map(root => (
                <div key={root.id} className="col-span-6 screen:col-span-4">
                    <GroupTree 
                        rootId={root.parent}
                        treeData={treeItems}
                        role={'employees'}
                        onUpdate={onUpdate}
                    />
                </div>
            ))}
        </div>
    )
}